import { Grid, Chip, Box, Paper, Typography } from "@material-ui/core";
import { PricingByClientStyle } from "../PricingByClientStyle";

// Legend component showing pricing indicators
const PricingLegend = () => {
    const classes = PricingByClientStyle();

    return (
        <Paper className={classes.legendPaper}>
            <Grid container spacing={3} alignItems="center">
                <Grid item>
                    <Box display="flex" alignItems="center">
                        <Chip
                            label="PMF vendor"
                            size="small"
                            className={classes.legendChip}
                        />
                    </Box>
                </Grid>
                <Grid item>
                    <Box display="flex" alignItems="center">
                        <Box className={`${classes.legendBox} ${classes.legendVarianceBox}`} />
                        <Typography variant="body2">Price variance</Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Box display="flex" alignItems="center">
                        <Box className={`${classes.legendBox} ${classes.legendLowMarginBox}`} />
                        <Typography variant="body2">Low margin</Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Box display="flex" alignItems="center">
                        <Box className={`${classes.legendBox} ${classes.legendNotConfiguredBox}`} />
                        <Typography variant="body2" className={classes.legendNotConfiguredText}>
                            Not configured
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default PricingLegend;
